import React from 'react';
import './portfolio.css';
import Portfolio1 from '../../assets/portfolio-1.png';
import Portfolio2 from '../../assets/portfolio-2.png';
import Portfolio3 from '../../assets/portfolio-3.png';
import Portfolio4 from '../../assets/portfolio-4.png';
import Portfolio5 from '../../assets/portfolio-5.png';
import Portfolio6 from '../../assets/portfolio-6.png';

const portfolio = () => {
  return (
    <section id="portfolio">
        <h2 className="portfolioTitle">Works Done</h2>
        <span className="portfolioPara">Check out some of my latest works:</span>
        <div className="portfolioGrid">
            <button className="project">
                <div className="portfolioItem">
                    <img src={Portfolio1} alt="" className="worksImg"/>
                </div>
                <span className="projectTitle">
                    articulAIt
                </span>
                <span className="projectDesc">
                    Two way translation for hearing impaired individuals to speak using sign language and read voice detected replies.
                </span>
            </button>
            <button className="project">
                <div className="portfolioItem">
                    <img src={Portfolio2} alt="" className="worksImg"/>
                </div>
                <span className="projectTitle">
                    FRC 2023 Robot
                </span>
                <span className="projectDesc">
                    Designed and programmed a swerve drive robot that could deliver cubes and auto-balance on a platform.
                </span>
            </button>
            <button className="project">
                <div className="portfolioItem">
                    <img src={Portfolio3} alt="" className="worksImg"/>
                </div>
                <span className="projectTitle">
                    Finger Mouse
                </span>
                <span className="projectDesc">
                    Move and click the mouse with your fingertips by using a webcam.
                </span>
            </button>
            <button className="project">
                <div className="portfolioItem">
                    <img src={Portfolio4} alt="" className="worksImg"/>
                </div>
                <span className="projectTitle">
                    SRM Plano App
                </span>
                <span className="projectDesc">
                    Created an app for a Hindu temple in Plano to help users connect with events, donate, sponsor, and more.
                </span>
            </button>
            <button className="project">
                <div className="portfolioItem">
                    <img src={Portfolio5} alt="" className="worksImg"/>
                </div>
                <span className="projectTitle">
                    Magic Dino Game
                </span>
                <span className="projectDesc">
                    Play the classic Chrome Dino Game- with a computer vision twist.
                </span>
            </button>
            <a href="https://github.com/praneelseth" target="_blank" rel="noopener noreferrer">
                <button className="githubLink">
                    <div className="portfolioItem">
                        <img src={Portfolio6} alt="" className="worksImg"/>
                    </div>
                    <span className="githubText">
                        See More on Github ↗️
                    </span>
                </button>
            </a>
        </div>
    </section>
  )
}

export default portfolio;
